export default __webpack_public_path__ + "static/media/guest_04_fernanda_nagano.c51a2d50.png";